/* eslint-disable react/jsx-props-no-spreading */
import { Col, Row, Form, Input, InputNumber } from 'antd';
import { ReactComponent as IconReloj } from 'assets/images/monitoreos/SIMAC_Icono_reloj.svg';
import PropTypes from 'prop-types';
import * as fieldMsgs from 'constants/formFieldsMessages';

const ComplementoVisita = ({ form }) => {
  const { TextArea } = Input;

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24} className="col-reloj-completo">
            <Form.Item label="Duración del evento:" required>
              <div className="div-reloj-campo-completo">
                <div>
                  <IconReloj className="reloj-icon-completo" />
                </div>
                <Form.Item
                  name="duracionHr"
                  className="item-duracion-evento"
                  rules={[
                    {
                      type: 'number',
                      min: 0,
                      max: 99,
                      message: (
                        <span className="error-message">
                          La duración debe estar entre 0 y 99 horas
                        </span>
                      )
                    },
                    {
                      required: true,
                      message: (
                        <span className="error-message">{`${fieldMsgs.ERR_SELECT_FIELD_REQUIRED} (hrs)`}</span>
                      )
                    }
                  ]}
                  validateStatus={form.getFieldError('duracionHr').length ? 'error' : ''}
                  help="">
                  <InputNumber
                    className="reloj-input-completo"
                    placeholder="00"
                    min={0}
                    max={99}
                    keyboard
                  />
                </Form.Item>
                <div className="div-p-time">
                  <p>hrs.</p>
                </div>
                <Form.Item
                  name="duracionMin"
                  className="item-duracion-evento"
                  rules={[
                    {
                      type: 'number',
                      min: 0,
                      max: 60,
                      message: (
                        <span className="error-message">
                          La duración debe estar entre 0 y 60 minutos
                        </span>
                      )
                    },
                    {
                      required: true,
                      message: (
                        <span className="error-message">{`${fieldMsgs.ERR_SELECT_FIELD_REQUIRED} (min)`}</span>
                      )
                    }
                  ]}
                  validateStatus={form.getFieldError('duracionMin').length ? 'error' : ''}
                  help="">
                  <InputNumber
                    className="reloj-input-completo"
                    placeholder="00"
                    min={0}
                    max={60}
                    keyboard
                  />
                </Form.Item>
                <div className="div-p-time">
                  <p>min.</p>
                </div>
                <Form.Item
                  name="duracionSeg"
                  className="item-duracion-evento"
                  rules={[
                    {
                      type: 'number',
                      min: 0,
                      max: 59,
                      message: (
                        <span className="error-message">
                          La duración debe estar entre 0 y 60 segundos
                        </span>
                      )
                    },
                    {
                      required: true,
                      message: (
                        <span className="error-message">{`${fieldMsgs.ERR_SELECT_FIELD_REQUIRED} (seg)`}</span>
                      )
                    }
                  ]}
                  validateStatus={form.getFieldError('duracionSeg').length ? 'error' : ''}
                  help="">
                  <InputNumber
                    className="reloj-input-completo"
                    placeholder="00"
                    min={0}
                    max={60}
                    keyboard
                  />
                </Form.Item>
                <div className="div-p-time">
                  <p>seg.</p>
                </div>
              </div>
            </Form.Item>
            <Form.ErrorList
              errors={form
                .getFieldsError()
                .filter(
                  ({ name }) =>
                    name.includes('duracionHr') ||
                    name.includes('duracionMin') ||
                    name.includes('duracionSeg')
                )
                .map(({ errors }) => errors)
                .flat()}
            />
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-textarea"
              name="manifestacion"
              label="Manifestación del compareciente:">
              <TextArea
                showCount
                maxLength={3800}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item className="input-textarea" name="otrosHechos" label="Otros hechos:">
              <TextArea
                showCount
                maxLength={1200}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-textarea-small"
              name="identificadorEvento"
              label="Identificador del evento:">
              <TextArea showCount maxLength={20} allowClear placeholder="Escribe..." size="small" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-textarea"
              name="infAdicional"
              label="Información adicional (modo, tiempo, lugar):">
              <TextArea
                showCount
                maxLength={5000}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

ComplementoVisita.propTypes = {
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func,
    getFieldsError: PropTypes.func,
    getFieldError: PropTypes.func
  }).isRequired
};

export default ComplementoVisita;
